<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="para"> </p>
<p class="para"> </p>
<p class="paralef"><strong>Suzanne Harrison</strong> is an Australian journalist and editor who has lived in Hong Kong since 1999. She most recently worked freelance, writing lifestyle and news features for the <em>South China Morning Post</em>.</p>
<p class="center2">Follow Suzanne on Instagram<br/><a href="mailto:@suzannejs.455">@suzannejs.455</a><br/>or on Twitter<br/><a href="https://twitter.com/suzannej123?lang=en" target="_blank">@suzannej123</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?3783478b